// @flow

import React, { type Node } from 'react';
import { SpinnerContainer, Spinner } from './loading-screen.styles';

export function LoadingScreen(): Node {
  return (
    <SpinnerContainer>
      <Spinner />
    </SpinnerContainer>
  );
}
